import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from '@assetmark/ui-components';
import styles from './HeaderSkeleton.module.scss';
const USER_AVATAR_WIDTH = '28px';
const BANNER_STYLES = {
    container: {
        gap: '1rem',
    },
    logoCol: {
        flex: '0 0 100px',
        fontSize: '13px',
        position: 'relative',
    },
    userMenuCol: {
        flex: '1 0 50px',
        position: 'relative',
        overflow: 'hidden',
    },
    userMenuContainer: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '1rem',
    },
    userMenuAvatarCol: {
        flex: `0 0 ${USER_AVATAR_WIDTH}`,
        fontSize: USER_AVATAR_WIDTH,
        width: USER_AVATAR_WIDTH,
    },
    userMenuUsernameCol: {
        flex: '0 1 113px',
        fontSize: '0.875rem',
    },
    appNameCol: {
        flex: '0 1 170px',
        fontSize: '0.875rem',
        paddingRight: '2rem',
    },
};
const NAVIGATION_STYLES = {
    container: {
        height: '46px',
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
    },
    menuItem: {
        flex: '0 0 88px',
    },
};
export const HeaderSkeleton = () => {
    return (_jsxs("div", { className: styles.header, children: [_jsxs("div", { className: styles.banner, style: BANNER_STYLES.container, "data-testid": "skeletonScreen", children: [_jsx("div", { style: BANNER_STYLES.logoCol, children: _jsx(Skeleton, {}) }), _jsx("div", { style: BANNER_STYLES.userMenuCol, children: _jsxs("div", { style: BANNER_STYLES.userMenuContainer, children: [_jsx("div", { style: BANNER_STYLES.appNameCol, children: _jsx(Skeleton, {}) }), _jsx("div", { style: BANNER_STYLES.userMenuAvatarCol, children: _jsx(Skeleton, { circle: true }) }), _jsx("div", { style: BANNER_STYLES.userMenuUsernameCol, children: _jsx(Skeleton, {}) })] }) })] }), _jsx("div", { className: styles.tabs, style: NAVIGATION_STYLES.container, children: new Array(6).fill(0).map((item, idx) => (_jsx("div", { style: NAVIGATION_STYLES.menuItem, children: _jsx(Skeleton, {}) }, idx))) })] }));
};
